module.exports = __webpack_public_path__ + "img/OverseaMember64.cd86c76f.png";